import React from 'react';

const Tickets = () => {
    return null;
}

export default Tickets;
